import { defineStore } from 'pinia'
import api from '@/stores/api'
import { useProductsStore } from './products'
import i18n from '@/plugins/i18n/i18n'


export const useFilterStore = defineStore('filters', {
    state: () => ({
        filters: [],
        appliedFilters: {},
        updatedFilters: {},
        selectedFilters: {}
    }),
    actions: {
        async loadFilterFromApi ()
        {
            try
            {
                const params = {}
                if (window.app.model_list.product)
                {
                    params['product[equals]'] = window.app.model_list.product
                }
                await api.get('/attribute-type/', { params })
                    .then(response =>
                    {
                        this.filters = response.data
                        this.filters.forEach((filter) =>
                        {
                            filter.values = Object.entries(Object.entries(filter.attributes)
                                .map(([, value]) => value.title))
                                .map(([, value]) => value)
                        })
                        useProductsStore()
                            .applyFilters()
                        this.filters.push(
                            {
                                title: i18n.global.t('filter.type.label'),
                                values: useProductsStore()
                                    .products
                                    .map((product) => product.product.title)
                                    .filter((value, index, self) => self.findIndex((el) => el === value) === index)
                            }
                        )
                    })
            } catch (error)
            {
                // eslint-disable-next-line
                console.error('Error loading filters:', error)
            }

        },
        updateFilters ()
        {
            // iterate over filteredproducts and attributes of variants in each product and add the attribute to the updatedFilters
            this.filters.forEach((filter) =>
                {
                    this.updatedFilters[filter.title] = []
                }
            )
            useProductsStore()
                .modelVariants
                .forEach((product) =>
                    {
                        product.variants.forEach((variant) =>
                        {
                            variant.attributes.forEach((attribute) =>
                            {
                                if (this.updatedFilters[attribute.type.title] && !this.updatedFilters[attribute.type.title].some(filter => filter === attribute.title))
                                {
                                    this.updatedFilters[attribute.type.title].push(attribute.title)
                                }
                            })
                        })

                        // these filter should be added to the filters differently because it is not a attribute type in the database
                        this.updatedFilters[i18n.global.t('filter.type.label')] = useProductsStore()
                            .filteredProducts
                            .map((product) =>
                            {
                                return product.type
                            })
                            .filter((value, index, self) => self.findIndex((el) => el === value) === index)
                    }
                )
        }
    }
})
